import { DateLocalizer } from 'react-big-calendar';
import { format } from 'date-fns';
import { pl, enGB } from 'date-fns/locale';

export function wallDate(date, time = '12:00') {
  const [year, month, day] = date.split('-').map(Number);
  const [hour, minute] = time.split(':').map(Number);
  return new Date(year, month - 1, day, hour, minute);
}

export function schoolNow(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(now);
  const part = name => parts.find(item => item.type === name).value;
  return wallDate(`${part('year')}-${part('month')}-${part('day')}`, `${part('hour')}:${part('minute')}`);
}

const timeRange = ({ start, end }, culture, localizer) => `${localizer.format(start, 'HH:mm', culture)}–${localizer.format(end, 'HH:mm', culture)}`;
export const publicLocalizer = new DateLocalizer({
  firstOfWeek: () => 1,
  format: (value, pattern, culture) => format(value, pattern, { locale: culture === 'en' ? enGB : pl }),
  formats: {
    timeGutterFormat: 'HH:mm',
    dayFormat: 'EEEE',
    dayHeaderFormat: 'EEEE',
    weekdayFormat: 'EEEE',
    dayRangeHeaderFormat: () => '',
    eventTimeRangeFormat: timeRange,
    selectRangeFormat: timeRange,
  },
});

// Give every connected overlap cluster equally wide, non-overlapping lanes.
// Endpoints touching at the same minute do not overlap.
export function calendarEvents(lessons) {
  const events = lessons.map((lesson, id) => ({ id, lesson, start: wallDate(lesson.date, lesson.startTime), end: wallDate(lesson.date, lesson.endTime) }))
    .sort((a, b) => a.start - b.start || b.end - a.end || a.id - b.id);
  const result = [];
  let cluster = [];
  let laneEnds = [];
  let clusterEnd = 0;
  const finish = () => result.push(...cluster.map(event => ({ ...event, lanes: laneEnds.length })));
  events.forEach(event => {
    if (event.start >= clusterEnd) { finish(); cluster = []; laneEnds = []; }
    let lane = laneEnds.findIndex(end => end <= event.start);
    if (lane < 0) lane = laneEnds.length;
    laneEnds[lane] = event.end;
    cluster.push({ ...event, lane });
    clusterEnd = Math.max(...laneEnds.map(Number));
  });
  finish();
  return result;
}

export function timeBounds(events, date) {
  const minutes = value => value.getHours() * 60 + value.getMinutes();
  const start = events.length ? Math.floor(Math.min(...events.map(event => minutes(event.start))) / 60) : 8;
  const end = events.length ? Math.ceil(Math.max(...events.map(event => minutes(event.end))) / 60) : 20;
  const min = new Date(date); min.setHours(start, 0, 0, 0);
  const max = new Date(date); max.setHours(Math.min(23, Math.max(start + 1, end)), end >= 24 ? 59 : 0, 0, 0);
  return { min, max };
}
